// UI Theme
import '@/styles/index.scss';

import {createApp} from 'vue';
import {sync} from 'vuex-router-sync';
import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';
import ToastService from 'primevue/toastservice';
import switchPreviewInterceptor from '@/api/interceptors/base/switchPreviewInterceptor';

import {
  // Plugins
  create$Fetch,
  createApplicationInsights,
  createAxios,
  createKeycloak,
  createMsal,
  // createAuthorization,
  createRouter,
  createStore,
  createWebVitals,

  // Directives
  roles,
  sortable,

  // Composables
  // useDev,

  // Config
  getAppConfig,
} from '@sttedra_ui/framework';
import {register} from 'ol/proj/proj4';

import App from './App.vue';
import {routes, hooks, routerOptions} from './routes';
import appModule from './modules/app';
import mapModule from './modules/map';
import layersModule from './modules/layers';
import userLayersModule from './modules/user-layers';
import calcRouteModule from './modules/calc-route';
import reportUrlsModule from './modules/report-urls';
import tutorialModule from './modules/tutorial';
import {
  proj4,
  PROJECTION_25830,
  PROJECTION_3857,
  PROJECTION_4326,
} from '@/api/util-coordinates';
// (!) Show all STTEDRA logs
// useDev.showAll(); useDev.hideAll(); useDev.show('YOUR_REGEXP');

// #region Creation
const {
  $fetchConfig,
  applicationInsightsConfig,
  axiosConfig,
  isProduction,
  keycloakConfig,
  msalConfig,
  primeVueOptions,
  webVitalsConfig,
} = getAppConfig();

// const proj4 = require('proj4').default;
// Map raster
proj4.defs('EPSG:25830', PROJECTION_25830);
// Map tiles
proj4.defs('EPSG:3857', PROJECTION_3857);
// UI
proj4.defs('EPSG:4326', PROJECTION_4326);
register(proj4);
const app = createApp(App);
const router = createRouter(routes, hooks, {routerOptions});

const appInsights = createApplicationInsights(applicationInsightsConfig);
const webVitals = createWebVitals(webVitalsConfig);
const $fetch = create$Fetch();
const axios = createAxios();
const keycloak = createKeycloak(keycloakConfig);
const msal = createMsal(msalConfig);
const store = createStore(isProduction);
store.registerModule('app', appModule);
store.registerModule('map', mapModule);
store.registerModule('layers', layersModule);
store.registerModule('userLayers', userLayersModule);
store.registerModule('calcRoute', calcRouteModule);
store.registerModule('reports', reportUrlsModule);
store.registerModule('tutorial', tutorialModule);
// const authorization = createAuthorization();
// #endregion

// #region Mount
sync(store, router);

if (appInsights) {
  app.use(appInsights);
}

if (webVitals) {
  app.use(webVitals);
}

if (keycloak) {
  app.use(keycloak);
}

if (msal) {
  app.use(msal);
}

app.use($fetch, $fetchConfig);
app.use(PrimeVue, primeVueOptions);
app.use(axios, axiosConfig);
app.use(router);
app.use(store);
app.use(ToastService);

// Interceptor que cambia la URL base de las peticiones cuando se accede
// a la aplicación en modo preview
switchPreviewInterceptor();

// app.use(authorization, {
//   /**
//    * @returns {string[]|{roles: string[]; data: any;}}
//    */
//   api: () => {...},
// });

app.directive('sortable', sortable);
app.directive('roles', roles);
app.directive('tooltip', Tooltip);

let vm = null;
router.isReady()
  .then(() => {
    vm = app.mount('#' + VUE_APP_ID);
  });
// #endregion

export {vm, store, router}; // window.sttedra._root.vm
